import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ProductionBudget from 'src/views/Pages/Dashboard/ProductionBudget/ProductionBudget.vue';

const ProductionBudgetRoutes = {
    path: 'production',
    name: 'productionbudget.production_budget',
    component: MasterTab,
    props: { reference: 'productionBudgetTabs' },
    children: [
        {
            path: 'budget',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'productionbudget.production_budget',
                    component: ProductionBudget,
                    meta: {
                        prefix_permission: 'production_budget',
                    },
                },
            ],
        },
    ]
};

export default ProductionBudgetRoutes;